module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-care__period"
  }, [_c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n        Period " + _vm._s(_vm.index + 1) + "\n    ")]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Start of Loss of Earnings"
    }
  }, [_c('date-input', {
    ref: "startOfPeriod",
    on: {
      "input": function($event) {
        return _vm.calculateLoss()
      }
    },
    model: {
      value: (_vm.period.startOfPeriod),
      callback: function($$v) {
        _vm.$set(_vm.period, "startOfPeriod", $$v)
      },
      expression: "period.startOfPeriod"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodStartIsValid
    }
  }, [_vm._v("\n            Date is required, must be in the format DD/MM/YYYY and must be before the End of Loss of Earnings Date\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "End of Loss of Earnings"
    }
  }, [_c('date-input', {
    ref: "endOfPeriod",
    on: {
      "input": function($event) {
        return _vm.calculateLoss()
      }
    },
    model: {
      value: (_vm.period.endOfPeriod),
      callback: function($$v) {
        _vm.$set(_vm.period, "endOfPeriod", $$v)
      },
      expression: "period.endOfPeriod"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.periodEndIsValid
    }
  }, [_vm._v("\n            Date is required, must be in the format DD/MM/YYYY, and must be after the Start of Loss of Earnings Date\n        ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Employment Type"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.employmentType),
      expression: "period.employmentType"
    }],
    ref: "employmentType",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.period, "employmentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.calculateLoss()
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "employed"
    }
  }, [_vm._v("Employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "self_employed"
    }
  }, [_vm._v("Self-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "part_employed"
    }
  }, [_vm._v("Part-employed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "absence"
    }
  }, [_vm._v("Absent")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Employment Income"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs--half-calcs"
  }, [_c('div', {
    staticClass: "a-form-inputs__container a-form-inputs--pound"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.employmentIncome),
      expression: "period.employmentIncome"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "employmentIncome",
    attrs: {
      "autocomplete": "off",
      "type": "number"
    },
    domProps: {
      "value": (_vm.period.employmentIncome)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.period, "employmentIncome", $event.target.value)
      }, function($event) {
        return _vm.calculateLoss()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period.employmentNetGross),
      expression: "period.employmentNetGross"
    }],
    ref: "employmentNetGross",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.period, "employmentNetGross", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.calculateLoss()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "gross"
    }
  }, [_vm._v("Gross")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "net"
    }
  }, [_vm._v("Net")])])])])]), _vm._v(" "), _c('control', [_c('button', {
    staticClass: "a-button a-button--smaller",
    class: _vm.index === 0 ? 'disabled' : '',
    attrs: {
      "disabled": _vm.index === 0
    },
    on: {
      "click": function($event) {
        return _vm.deleteThisPeriod()
      }
    }
  }, [_vm._v("\n            Delete Income Period\n        ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0094a821!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/components/IncomePeriod.vue
// module id = 1553
// module chunks = 0